module.exports = "/images/emptyCart.svg";